"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var PreviewFrame_1 = __importDefault(require("./PreviewFrame/PreviewFrame"));
var Browser = (function () {
    function Browser(createUi, projectLinkRetriever, make, getTemplate, templateState) {
        var _this = this;
        var currentTemplateState;
        this.refresh = function (newTemplateState) {
            if (currentTemplateState &&
                currentTemplateState.projectId &&
                currentTemplateState.projectId === newTemplateState.projectId) {
                return;
            }
            currentTemplateState = lodash_1.default.cloneDeep(newTemplateState);
            var template = getTemplate(newTemplateState);
            var url;
            if (template) {
                url = projectLinkRetriever.getUrlForSecret(template.secret, true);
            }
            var previewFrame = make(PreviewFrame_1.default, { url: url });
            _this._ui.previewFrame = previewFrame.ui;
        };
        this._ui = createUi(require("./Browser.html"));
        this.refresh(templateState);
    }
    Object.defineProperty(Browser.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return Browser;
}());
exports.default = Browser;
